/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEstimatedLaborCostRequest } from '../../models/create-estimated-labor-cost-request';

export interface CreateEstimatedLaborCost$Params {
      body: CreateEstimatedLaborCostRequest
}

export function createEstimatedLaborCost(http: HttpClient, rootUrl: string, params: CreateEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, createEstimatedLaborCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

createEstimatedLaborCost.PATH = '/v0/estimatedLaborCost';
